import { email, loginPassword, required, Validator } from '@/entities/validation';
import { LoggingInUser } from './model';

export const validate: Validator<LoggingInUser> = user => [
  ...required(user.email, 'email'),
  ...email(user.email, 'email'),
  ...required(user.password, 'password'),
  ...loginPassword(user.password, 'password'),
];
